import React, { Component } from "react";
import { withRouter, Route } from "react-router-dom";
import { connect } from "react-redux";
import * as Const from "../../../Data/const";
import { action } from "../../../Data";
import { parseUrlParameter } from "../../../Lib/Utils";

// components

// styles

class LineRedirect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisible: true,
      loginType: ""
    };

    // 라인
    this.loadLineLoginApi = this.loadLineLoginApi.bind(this);
    this.href = "";
  }

  componentDidMount() {
    if (this.props.onRef !== undefined) this.props.onRef(this);
    this.loadLineLoginApi();
  }

  loadLineLoginApi() {
    const loginParams = {};

    this.href = parseUrlParameter.parse(this.props.location.search).state || "";
    const params = {
      grant_type: "authorization_code",
      client_id: Const.LINE.client_id,
      client_secret: Const.LINE.client_secret,
      code: parseUrlParameter.parse(this.props.location.search).code,
      redirect_uri: window.location.origin + window.location.pathname
    };

    this.href =
      this.href.substring(0, this.href.indexOf("?")) +
      this.href
        .substring(this.href.indexOf("?"), this.href.length)
        .replace(/,/gi, "&");

    const searchParams = Object.keys(params)
      .map(key => {
        return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
      })
      .join("&");

    const jsonPromise = fetch("https://api.line.me/oauth2/v2.1/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      },
      body: searchParams
    }).then(response => {
      return response.json();
    });

    const getProfilePromise = accessToken => {
      return fetch("https://api.line.me/v2/profile", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + accessToken
        }
      }).then(response => {
        return response.json();
      });
    };

    jsonPromise.then(data => {
      const lineAccessToken = data.access_token;
      getProfilePromise(lineAccessToken).then(data => {
        console.log(data);
        this.props
          .dispatch(
            action.eUSER.login({
              uid: "line!" + data.userId,
              snsToken: lineAccessToken
            })
          )
          .then(response => {
            console.log(response);
            if (!response.user) throw new Error("No User");
            Const.showAlert(
              "",
              response.user.name + "님 " + Const.LOGIN_SUCCESS_MESSAGE
            );
            localStorage.setItem(Const.TOKEN["user"], response.token);
            localStorage.setItem(Const.LOGIN_TIME["user"], new Date());

            let loginValue = null;
            if (response.user.email) {
              loginValue = response.user.email;
            } else {
              let uidTypeAndId = response.user.uid.split("!");

              loginValue = uidTypeAndId[1];
            }

            Const.onLoginSuccess(response.token, loginValue);

            console.log(this.href);
            this.props.history.push(this.href);
          })
          .catch(err => {
            Const.showAlert("", Const.LOGIN_WARNING_MESSAGE);
            this.props.history.push(this.href);
          });
        // 로그인 시작, loginParams에 uid와 토큰이 담겨있습니다.
      });
    });
  }

  render() {
    const { modalVisible } = this.state;
    if (!modalVisible) return null;

    return <div></div>;
  }
}

export default connect(state => {
  return {
    eSESSION: state.data.eSESSION.eSESSION
  };
})(withRouter(LineRedirect));
